import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionProps } from '@mui/material/Accordion/Accordion';
import { useFormShowContext } from 'framework/form';

export interface ProjectSectionAccordionProps extends Omit<AccordionProps, 'title'> {
  defaultExpanded?: boolean;
  title: React.ReactNode;
}

const ProjectSectionAccordion = ({
  title,
  children,
  defaultExpanded = false,
  ...props
}: ProjectSectionAccordionProps) => {
  const { isEditMode } = useFormShowContext();
  const [expanded, setExpanded] = useState(defaultExpanded);

  const handleChange = (event: any, isExpanded: boolean) => {
    const isExpandIconClick = event.target.closest('.MuiAccordionSummary-expandIconWrapper');

    if (isExpandIconClick) {
      setExpanded(isExpanded);
    }
  };

  const handleSummaryClick = (event: any) => {
    if (!event.target.closest('.MuiAccordionSummary-expandIconWrapper')) {
      event.stopPropagation();
    }
  };

  useEffect(() => {
    if (isEditMode) {
      setExpanded(true);
    }
  }, [isEditMode]);

  return (
    <Accordion expanded={expanded} onChange={handleChange} {...props} data-testid="project-section-accordion">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        onClick={handleSummaryClick}
        sx={{
          borderBottom: '1px solid var(--mui-palette-border-default)',
          flexDirection: 'row-reverse',
          '& .MuiAccordionSummary-content': {
            pointerEvents: 'auto',
            '&.Mui-expanded': {
              m: 0,
            },
          },
        }}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>{children}</AccordionDetails>
    </Accordion>
  );
};
export default ProjectSectionAccordion;
